const translations = {
  "en": {
    "$150/mo saved vs. going alone": "$150/mo saved vs. going alone",
    "2x more red flags caught early": "2x more red flags caught early",
    "3 days faster than solo investors": "3 days faster than solo investors",
    "40% fewer costly mistakes": "40% fewer costly mistakes",
    "92% renew after year one": "92% renew after year one",
    "Hi, I'm Ed.": "Hi, I'm Ed.",
    "I read 365 briefs a year, track 150+ feeds, and charge $0 commissions — clients end up +$400 ahead in month one.": "I read 365 briefs a year, track 150+ feeds, and charge $0 commissions — clients end up +$400 ahead in month one.",
    "I'd like to be your advisor.": "I'd like to be your advisor.",
    "Subscribers earn +$400/mo more": "Subscribers earn +$400/mo more"
  },
  "zh-tw": {
    "$150/mo saved vs. going alone": "比自行投資每月節省 $150",
    "2x more red flags caught early": "及早發現兩倍風險警訊",
    "3 days faster than solo investors": "比自行投資快 3 天",
    "40% fewer costly mistakes": "代價高昂的錯誤減少 40%",
    "92% renew after year one": "滿一年後續訂率 92%",
    "Hi, I'm Ed.": "您好，我是 Ed。",
    "I read 365 briefs a year, track 150+ feeds, and charge $0 commissions — clients end up +$400 ahead in month one.": "我每年閱讀 365 份簡報、追蹤 150 多個資訊來源，並收取 $0 佣金——客戶首月多得 $400。",
    "I'd like to be your advisor.": "我想成為你的顧問。",
    "Subscribers earn +$400/mo more": "訂閱用戶每月多賺 $400"
  }
};

export default translations;
